import { type FC, type ReactNode } from 'react'

import { IconArrowRight } from '@redteclab/icons'

import { Link } from 'base-ui'

export const ErxHubArrowLink: FC<{
  children: ReactNode
  url: string
}> = ({ children, url }) => {
  return (
    <Link
      className="flex justify-between gap-1 text-dark-primary-max no-underline"
      href={url}
    >
      {children}
      <IconArrowRight className="size-6 shrink-0 text-dark-brand" />
    </Link>
  )
}
